/*
 * kit-soldout.js — [Platypus 2026-09-22]
 *
 * A kit (Simple Bundles bundle) has its own stock, separate from the products inside it. When a
 * component sells out, the app greys out that component's options inside the kit — but the kit
 * itself stays "in stock": no Sold out badge, and an active Add to cart button.
 *
 * This makes a kit look exactly like any other sold-out product on its product page: the theme's
 * own Sold out badge on the price (.price--sold-out) and a disabled "Sold out" button. The rule:
 * if any of the kit's selectors has no option left to choose, the kit is sold out. It clears by
 * itself as soon as the component is back in stock, because the app re-enables the options.
 *
 * The app injects its selectors at runtime, after Liquid, and this theme swaps page bodies without
 * a reload — so the check runs from a MutationObserver on <body>, not once on load.
 * Scope: product page only. Product cards cannot see component stock.
 */
(function () {
  'use strict';

  if (window.__lfdKitSoldOut) return;
  window.__lfdKitSoldOut = true;

  function soldOutText() {
    return (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
  }

  // true when at least one bundle selector has real options and every one of them is disabled
  function hasDeadSelector(root) {
    var selects = root.querySelectorAll('.simple-bundle-choices select');
    for (var i = 0; i < selects.length; i++) {
      var real = Array.prototype.filter.call(selects[i].options, function (o) { return o.value !== ''; });
      if (real.length && real.every(function (o) { return o.disabled; })) return true;
    }
    return false;
  }

  function markSoldOut(root) {
    var button = root.querySelector('button[name="add"]');
    if (button) {
      if (!button.disabled) button.setAttribute('disabled', 'disabled');
      var label = button.querySelector('span');
      if (label && label.textContent.trim() !== soldOutText()) label.textContent = soldOutText();
    }
    var price = root.querySelector('.price');
    if (price && !price.classList.contains('price--sold-out')) price.classList.add('price--sold-out');
    var buyNow = root.querySelector('.shopify-payment-button');
    if (buyNow && buyNow.style.display !== 'none') buyNow.style.display = 'none';
  }

  function check() {
    var buttons = document.querySelectorAll('product-form button[name="add"]');
    Array.prototype.forEach.call(buttons, function (button) {
      var root = button.closest('product-info') || button.closest('section') || document;
      if (hasDeadSelector(root)) markSoldOut(root);
    });
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 150);
  }

  function start() {
    check();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
